module.exports = __webpack_public_path__ + "img/logo.cf71f8d9.svg";